import fetch from '@/utils/fetch';

export function menuCreate(params){

     return fetch({

         url:'ManageRule/ManageRule/saveMenu',
         method:"post",
         data:params

     })

}

export function getMenu(params){

     return fetch({

         url:'ManageRule/ManageRule/getMenuTree',
         method:"post",
         data:params

     })

}

export function delDot(params){

     return fetch({

         url:'ManageRule/ManageRule/delMenu',
         method:"post",
         data:params

     })

}



// WEBPACK FOOTER //
// ./src/api/pgMent/modelSet.js